import { __extends } from "tslib";
import React from 'react';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './UserAvatar.styles';
import { cx } from '@skbkontur/react-ui/lib/theming/Emotion';
import { UserIcon } from './UserIcon';
/**
 * Аватар пользователя
 */

var UserAvatar =
/** @class */
function (_super) {
  __extends(UserAvatar, _super);

  function UserAvatar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getInitials = function (userName) {
      return userName.split(' ').map(function (x) {
        return x.slice(0, 1);
      }).join('');
    };

    return _this;
  }

  UserAvatar.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return _this.renderMain();
    });
  };

  UserAvatar.prototype.renderMain = function () {
    var _a;

    var _b = this.props,
        avatarUrl = _b.avatarUrl,
        userName = _b.userName;
    var needShowDefaultAvatar = !userName || avatarUrl;
    return React.createElement("div", {
      className: jsStyles.root(this.theme)
    }, React.createElement("div", {
      className: cx(jsStyles.avatar(this.theme), (_a = {}, _a[jsStyles.defaultIconForImage()] = !!avatarUrl, // TODO: добиться универсальности дефолтной иконки относительно размера аватара
      _a[jsStyles.defaultIcon()] = !!needShowDefaultAvatar, _a))
    }, needShowDefaultAvatar ? React.createElement(UserIcon, null) : this.getInitials(userName)), avatarUrl && React.createElement("div", {
      className: jsStyles.avatarImage(this.theme),
      style: {
        backgroundImage: "url(" + avatarUrl + ")"
      }
    }));
  };

  UserAvatar.__KONTUR_REACT_UI__ = 'UserAvatar';
  return UserAvatar;
}(React.Component);

export { UserAvatar };